import script from "./Sky.vue?vue&type=script&setup=true&lang=js"
export * from "./Sky.vue?vue&type=script&setup=true&lang=js"

import "./Sky.vue?vue&type=style&index=0&id=bf4fe63e&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/prd-cce-chain-browser-static-nft/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf4fe63e"]])

export default __exports__